import axios, { AxiosInstance } from "axios"

import { VaultService } from "../services/vault.service.js"
import { apiUrlForEnvironment, TargetEnv } from "../types/environment.js"

export async function createApiClient(env: TargetEnv): Promise<AxiosInstance> {
  const token = await new VaultService().getTokensFromVault(env)

  return axios.create({
    baseURL: apiUrlForEnvironment(env),
    headers: {
      Authorization: `Bearer ${token.accessToken}`,
      "Content-Type": "application/json",
    },
    timeout: 30_000,
  })
}
